import { IonContent, IonList, IonIcon, IonLabel, IonItem, IonPage } from "@ionic/react";
import "./Home.css";
import readerIcon from "../assets/reader.svg";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { mk_ion_header } from "../functions/mk_ion_header";

export default function Funktionen() {
  const { appFunktionChange } = useContext(DataContext);

  const data_funktionen =
    [
      [ 'Bestellung (SOLL-Erfassung)' , 'bewohner' ] ,
      [ 'Verzehr (IST-Erfassung)' , 'bewohnerist' ] ,
      [ 'Stationsbedarf' , 'stationsbedarf' ]
    ]

  const mk_funktionen = () =>
    {
      let my_arr: any = data_funktionen.map( ( entry: any ) =>
        (
          <IonItem
            button
            key={ 'funktion_' + entry[ 1 ] }
            routerLink={`/stationen`}
            onClick={() => {
              appFunktionChange(entry[ 1 ]);
            }}
          >
            <IonIcon slot="start" icon={readerIcon}></IonIcon>
            <IonLabel>{ entry[ 0 ] }</IonLabel>
          </IonItem>
        )
      ) ;
      return my_arr ;
    }

  return (
    <IonPage>
      {mk_ion_header("Funktion")}
      <IonContent fullscreen>
        {mk_ion_header("Funktion", "large")}
        <IonList>
          { mk_funktionen() }
        </IonList>
      </IonContent>
    </IonPage>
  );
}
